export default __webpack_public_path__ + "static/media/checkeredFlag.195a7506.jpg";